import React from "react"

const Footer = () => {
  return (
    <footer className="page-footer">
      <p>&copy; {new Date().getFullYear()} Viet Dang</p>
    </footer>
  )
}

export default Footer
